/*
  SalonID — bestelkaart op de productpagina (sections/sid-main-product.liquid).

  Houdt de keuze bij (variant, doos of combipack, tweede combipack-product,
  aantal dozen), werkt prijzen en knoppen bij en voegt toe via /cart/add.js.
  Combipack-regels krijgen dezelfde eigenschappen als component-combipack.js
  ('Combipack' + verborgen '_combipack'), zodat de winkelwagen ze groepeert.
*/
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '€{{amount_with_comma_separator}}';
    var parts = value.split('.');
    var thousandsDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var thousandsComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousandsDot)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, thousandsComma);
  }

  function init(root) {
    if (root.dataset.sidReady) return;
    root.dataset.sidReady = 'true';

    // Binnenkort: geen bestelkaart, alleen de foto's wisselen.
    if (root.hasAttribute('data-sid-soon')) {
      root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          root.querySelectorAll('[data-media-id]').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.dataset.mediaId === thumb.dataset.thumb);
          });
          root.querySelectorAll('[data-thumb]').forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        });
      });
      return;
    }

    var variants = JSON.parse(root.querySelector('[data-sid-variants]').textContent);
    var strings = JSON.parse(root.querySelector('[data-sid-strings]').textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var money = function (cents) { return formatMoney(cents, moneyFormat); };

    var form = root.querySelector('[data-sid-form]');
    var variantInput = root.querySelector('[data-variant-input]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var unitPrice = root.querySelector('[data-unit-price]');
    var variantTitle = root.querySelector('[data-variant-title]');
    var orderType = root.querySelector('[data-order-type]');
    var boxTitle = root.querySelector('[data-box-title]');
    var boxPrice = root.querySelector('[data-box-price]');
    var combiOption = root.querySelector('[data-combi-option]');
    var combiText = root.querySelector('[data-combi-text]');
    var combiSummary = root.querySelector('[data-combi-summary]');
    var combiFrom = root.querySelector('[data-combi-from]');
    var combiPanel = root.querySelector('[data-combi-panel]');
    var combiSelect = root.querySelector('[data-combi-select]');
    var boxesLabel = root.querySelector('[data-boxes-label]');
    var piecesLabel = root.querySelector('[data-pieces-label]');
    var submit = root.querySelector('[data-submit]');
    var submitLabel = root.querySelector('[data-submit-label]');
    var submitPrice = root.querySelector('[data-submit-price]');
    var totalPrice = root.querySelector('[data-total-price]');
    var errorEl = root.querySelector('[data-error]');

    var state = {
      variant: variants.find(function (v) { return String(v.id) === variantInput.value; }) || variants[0],
      mode: 'box',
      secondId: null,
      boxes: 1,
      busy: false,
    };

    function showError(message) {
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }

    function optionName(o) {
      return o.size ? o.name + ' ' + o.size : o.name;
    }

    function second() {
      var combi = state.variant.combi;
      if (!combi || !state.secondId) return null;
      return combi.options.find(function (o) { return o.id === state.secondId; }) || null;
    }

    function total() {
      var v = state.variant;
      if (state.mode === 'combi' && v.combi) {
        var s = second();
        var secondPrice = s ? s.price : v.price;
        return (v.price + secondPrice) * v.combi.each * state.boxes;
      }
      return v.price * v.inc * state.boxes;
    }

    function pieces() {
      var v = state.variant;
      return state.mode === 'combi' && v.combi ? v.combi.each * 2 * state.boxes : v.inc * state.boxes;
    }

    function fillCombiSelect() {
      var combi = state.variant.combi;
      while (combiSelect.options.length > 1) combiSelect.remove(1);
      if (!combi) return;
      combi.options.forEach(function (o) {
        var option = document.createElement('option');
        option.value = o.id;
        option.textContent = strings.combiOption.replace('[name]', optionName(o)).replace('[price]', money(o.price));
        option.disabled = !o.available;
        combiSelect.appendChild(option);
      });
      var stillThere = combi.options.some(function (o) { return o.id === state.secondId; });
      if (!stillThere) state.secondId = null;
      combiSelect.value = state.secondId ? String(state.secondId) : '';
    }

    function render() {
      var v = state.variant;
      var combi = v.combi;

      unitPrice.textContent = money(v.price);
      if (variantTitle) variantTitle.textContent = v.title;
      boxTitle.textContent = strings.boxTitle.replace('[count]', v.inc);
      boxPrice.textContent = money(v.price * v.inc);

      if (combi) {
        orderType.hidden = false;
        combiOption.hidden = false;
        combiText.textContent = strings.combiText.replace(/\[each\]/g, combi.each);
        var cheapest = combi.options.reduce(function (min, o) { return o.available && o.price < min ? o.price : min; }, Infinity);
        var fromPrice = (v.price + (cheapest === Infinity ? v.price : cheapest)) * combi.each;
        combiFrom.textContent = strings.from.replace('[price]', money(fromPrice));
      } else {
        orderType.hidden = true;
        combiOption.hidden = true;
        if (state.mode === 'combi') {
          state.mode = 'box';
          root.querySelector('[data-order-radio][value="box"]').checked = true;
        }
      }
      combiPanel.hidden = !(state.mode === 'combi' && combi);
      var chosen = second();
      if (state.mode === 'combi' && combi && chosen) {
        combiSummary.hidden = false;
        combiSummary.textContent = strings.combiSummary
          .replace(/\[each\]/g, combi.each)
          .replace('[second]', optionName(chosen))
          .replace('[price]', money((v.price + chosen.price) * combi.each));
      } else {
        combiSummary.hidden = true;
      }

      var useCombi = state.mode === 'combi' && combi;
      var one = useCombi ? strings.combisOne : strings.boxesOne;
      var other = useCombi ? strings.combisOther : strings.boxesOther;
      boxesLabel.textContent = state.boxes === 1 ? one : other.replace('[count]', state.boxes);
      piecesLabel.textContent = strings.pieces.replace('[count]', pieces());

      variantInput.value = v.id;
      quantityInput.value = v.inc * state.boxes;

      submit.disabled = !v.available || state.busy;
      // De prijs staat in een eigen element: op desktop in de knop, op mobiel in de teller erboven.
      var priceText = money(total());
      if (!v.available) {
        submitLabel.textContent = strings.soldOut;
        if (submitPrice) submitPrice.textContent = '';
      } else if (state.busy) {
        submitLabel.textContent = strings.adding;
        if (submitPrice) submitPrice.textContent = '';
      } else {
        // Ook bij een combipack kort "In winkelwagen": de gekozen optie staat er vlak boven
        submitLabel.textContent = strings.add;
        if (submitPrice) submitPrice.textContent = ' \u00b7 ' + priceText;
      }
      if (totalPrice) totalPrice.textContent = priceText;

      root.querySelectorAll('[data-variant-radio]').forEach(function (radio) {
        var label = radio.closest('.sid-option');
        if (label) label.classList.toggle('is-selected', radio.checked);
      });
      root.querySelectorAll('[data-order-radio]').forEach(function (radio) {
        var label = radio.closest('.sid-order');
        if (label) label.classList.toggle('is-selected', radio.checked);
      });
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var slides = root.querySelectorAll('[data-media-id]');
      var found = false;
      slides.forEach(function (slide) {
        var match = slide.dataset.mediaId === String(mediaId);
        slide.classList.toggle('is-active', match);
        if (match) found = true;
      });
      if (!found && slides.length) slides[0].classList.add('is-active');
      root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.thumb === String(mediaId));
      });
    }

    root.querySelectorAll('[data-variant-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === radio.value; });
        if (!v) return;
        state.variant = v;
        showError('');
        fillCombiSelect();
        showMedia(v.media);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        render();
      });
    });

    root.querySelectorAll('[data-order-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.mode = radio.value;
        showError('');
        render();
        if (state.mode === 'combi') combiSelect.focus({ preventScroll: true });
      });
    });

    combiSelect.addEventListener('change', function () {
      state.secondId = combiSelect.value ? parseInt(combiSelect.value, 10) : null;
      showError('');
      render();
    });

    root.querySelectorAll('[data-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.boxes = Math.max(1, Math.min(99, state.boxes + parseInt(button.dataset.step, 10)));
        render();
      });
    });

    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumb); });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (state.busy) return;
      var v = state.variant;
      var items;

      if (state.mode === 'combi' && v.combi) {
        var s = second();
        if (!s) {
          showError(strings.combiMissing);
          combiSelect.focus();
          return;
        }
        var quantity = v.combi.each * state.boxes;
        var ids = [v.id, s.id];
        var token = v.combi.handle + ':' + ids.slice().sort(function (a, b) { return a - b; }).join('+') + ':' + Date.now().toString(36);
        var properties = { 'Combipack': v.combi.title, '_combipack': token };
        items = [];
        ids.forEach(function (id) {
          var existing = items.find(function (item) { return item.id === id; });
          if (existing) existing.quantity += quantity;
          else items.push({ id: id, quantity: quantity, properties: properties });
        });
      } else {
        items = [{ id: v.id, quantity: v.inc * state.boxes }];
      }

      // Geopend vanuit SalonID Studio (?studio=<rangenummer>): het nummer gaat als
      // verborgen regeleigenschap mee, zodat de Studio na het betalen weet voor
      // welke range het was (het premium ontwerp). Zonder ?studio= verandert er niets.
      var studio = (new URLSearchParams(window.location.search).get('studio') || '').trim();
      if (/^(r\/)?[A-Za-z0-9_-]{1,64}$/.test(studio)) {   // ook "r/<nummer>", zoals de Studio het schrijft
        items.forEach(function (item) {
          item.properties = Object.assign({}, item.properties, { _studio: studio });
        });
      }

      state.busy = true;
      showError('');
      render();

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.description || json.message || strings.error);
            return json;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function (error) {
          showError(error.message || strings.error);
        })
        .then(function () {
          state.busy = false;
          render();
        });
    });

    fillCombiSelect();
    render();
  }


  /*
    Uitklapblokken (sid-product-info): één tegelijk open, zacht openen en
    sluiten. Klik je tijdens een animatie, dan draait die vanaf de huidige
    stand om.

    Scrollgedrag. Gaat een blok bóven het aangeklikte blok dicht, dan schuift
    alles eronder omhoog en kan het aangeklikte blok achter de header
    verdwijnen. Daarom gaat alleen het deel van dat blok dat al boven de
    bovenrand van het beeld staat (onder de zichtbare header) in één keer
    weg, in dezelfde frame gecompenseerd met window.scrollBy: dat deel stond
    toch al buiten beeld, dus in beeld verspringt niets. Het zichtbare deel
    klapt gewoon dicht, zodat het aangeklikte blok hooguit op de bovenrand
    landt. Eén directe correctie dus, geen scroll-lus per frame. De sticky
    header krijgt via 'theme:scroll-adjust' het seintje dat dit geen
    scrollen van de gebruiker is (global.js). Minder beweging: alles direct,
    met dezelfde correctie.
  */
  function initAccordions() {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE_OPEN = 'cubic-bezier(0.16, 1, 0.3, 1)';
    var EASE_CLOSE = 'cubic-bezier(0.33, 0, 0.2, 1)';
    var MARGIN = 16;
    var running = 0;
    var anchoringPaused = false;

    // Bovenrand van het bruikbare beeld: onder de zichtbare sticky header,
    // met wat lucht. Een weggeschoven header telt niet mee.
    function topLine() {
      var header = document.querySelector('header.header');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      return Math.max(0, bottom) + MARGIN;
    }

    // Verschuif de pagina direct (geen smooth scroll) en meld de header dat
    // dit geen scrollen van de gebruiker is.
    function shift(delta) {
      if (Math.abs(delta) < 0.5) return;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      document.dispatchEvent(new CustomEvent('theme:scroll-adjust', { detail: { delta: delta } }));
      window.scrollBy(0, delta);
      root.style.scrollBehavior = prev;
    }

    // Scroll anchoring van de browser uit zolang wij zelf schuiven, anders
    // corrigeert die er nog eens overheen. Weer aan zodra alles stilstaat.
    function pauseAnchoring() {
      if (anchoringPaused) return;
      anchoringPaused = true;
      root.style.overflowAnchor = 'none';
    }
    function resumeAnchoring() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (running > 0 || !anchoringPaused) return;
          anchoringPaused = false;
          root.style.overflowAnchor = '';
        });
      });
    }

    // Zoveel px van de bovenkant van de inhoud is weggenomen.
    function setTrim(d, px) {
      d._sidTrim = px;
      var inner = d.querySelector('.sid-acc__inner');
      if (inner) inner.style.transform = px > 0 ? 'translateY(' + -px + 'px)' : '';
    }

    function settle(d, open) {
      d._sidAnim = null;
      d.open = open;
      d.classList.remove('is-closing', 'is-animating');
      if (!open) setTrim(d, 0);
    }

    // Zet `d` open of dicht, geanimeerd vanaf de huidige stand. `cut` is het
    // aantal px dat direct van de bovenkant af gaat (sluiten) of er weer bij
    // komt (openen); de aanroeper compenseert de scroll met hetzelfde aantal.
    function animateItem(d, open, cut) {
      var body = d.querySelector('.sid-acc__body');
      var height = 0;
      var padding = 0;
      var opacity = '0';
      if (d.open) {
        var cs = getComputedStyle(body);
        height = parseFloat(cs.height) || 0;
        padding = parseFloat(cs.paddingBottom) || 0;
        opacity = cs.opacity;
      }
      var prev = d._sidAnim;
      d._sidAnim = null;
      if (prev) prev.cancel();

      if (open) {
        height += cut;
        setTrim(d, 0);
      } else {
        height = Math.max(0, height - cut);
        setTrim(d, (d._sidTrim || 0) + cut);
      }

      if (reduce || !body.animate) {
        settle(d, open);
        return;
      }
      d.open = true;
      var from = { height: height + 'px', paddingBottom: Math.min(padding, height) + 'px', opacity: opacity };
      var to = open
        ? { height: body.offsetHeight + 'px', paddingBottom: getComputedStyle(body).paddingBottom, opacity: 1 }
        : { height: '0px', paddingBottom: '0px', opacity: 0 };
      d.classList.add('is-animating');
      d.classList.toggle('is-closing', !open);
      var anim = body.animate([from, to], {
        duration: open ? 460 : 360,
        easing: open ? EASE_OPEN : EASE_CLOSE,
        fill: 'forwards'
      });
      d._sidAnim = anim;
      running++;
      anim.finished.then(function () {
        running--;
        if (d._sidAnim === anim) {
          settle(d, open);
          anim.cancel();
        }
        resumeAnchoring();
      }, function () {
        running--;
        resumeAnchoring();
      });
    }

    document.querySelectorAll('[data-sid-acc-group]').forEach(function (group) {
      if (group.dataset.sidAccReady) return;
      group.dataset.sidAccReady = 'true';
      var items = Array.prototype.slice.call(group.querySelectorAll('details.sid-acc'));
      // Op mobiel beginnen ook de blokken die op desktop open staan dicht:
      // dan blijft de lijst kort en kies je zelf wat je wilt lezen.
      if (window.matchMedia('(max-width: 749px)').matches) {
        items.forEach(function (d) { if (d.hasAttribute('data-mobile-closed')) d.open = false; });
      }
      var isOpen = function (d) { return d.open && !d.classList.contains('is-closing'); };

      items.forEach(function (d) {
        var summary = d.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          pauseAnchoring();
          if (isOpen(d)) {
            animateItem(d, false, 0);
          } else {
            var line = topLine();
            items.forEach(function (other) {
              if (other === d || !isOpen(other)) return;
              var cut = 0;
              if (other.compareDocumentPosition(d) & Node.DOCUMENT_POSITION_FOLLOWING) {
                // `other` staat boven d: het deel boven de bovenrand gaat direct weg.
                var rect = other.querySelector('.sid-acc__body').getBoundingClientRect();
                cut = Math.round(Math.max(0, Math.min(rect.height, line - rect.top)));
              }
              animateItem(other, false, cut);
              shift(-cut);
            });
            // Sloot d nog met een afgesneden bovenkant, dan komt die nu terug.
            var back = d._sidTrim || 0;
            animateItem(d, true, back);
            shift(back);
          }
          resumeAnchoring();
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-sid-pdp]').forEach(init);
    initAccordions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
